import { TextInput, EnumDropdown } from 'framework/form';
import { Box, Grid2 as Grid } from '@mui/material';
import { MILESTONES_LABELS } from 'domain/projects/newProject/milestones/useMilestonesService';
import { InvoiceTotalInput } from 'domain/shared/core/invoice';
import { useFieldHelper } from 'framework/ui/field';
import { BillingChangeRequestItem, BillingMilestone } from '../../types';
import {
  isBillingScheduleItemFullyLocked,
  isBillingScheduleItemStructureLocked,
} from '../../helpers/projectBillingHelper';

const { NON_BILLING_MILESTONE, ...BILLING_MILESTONES } = MILESTONES_LABELS;

const isChangeRequestItem = (value?: BillingMilestone | BillingChangeRequestItem): value is BillingChangeRequestItem =>
  value?.itemType === 'CHANGE_REQUEST';

const formatChangeRequestAlias = (changeRequestAlias?: string) =>
  changeRequestAlias ? `Change Request ${changeRequestAlias}` : '';

const BillingProjectMilestonesInputs = ({
  source,
  index,
  value,
}: {
  source: string;
  index?: number;
  value?: BillingMilestone | BillingChangeRequestItem;
}) => {
  const { getValue } = useFieldHelper<string>({ source: `${source}.alias` });
  const alias = getValue();
  const isFullyLocked = isBillingScheduleItemFullyLocked(value);
  const isStructureLocked = isBillingScheduleItemStructureLocked(value);

  if (isChangeRequestItem(value)) {
    return (
      <Grid container width="100%" columnSpacing="60px">
        <Grid size={6} display="flex" alignItems="flex-start" justifyContent="flex-start">
          <Box
            sx={{
              padding: '7px',
              border: '1px solid var(--mui-palette-border-default)',
              borderRadius: '3px',
              backgroundColor: 'var(--mui-palette-background-default)',
              color: 'var(--mui-palette-text-secondary)',
              mr: '5px',
            }}
          >
            {value?.changeRequestAlias || `CR${index !== undefined ? index + 1 : ''}`}
          </Box>
          <TextInput
            disabled
            source={`${source}.changeRequestAlias`}
            label="Change request"
            value={formatChangeRequestAlias(value?.changeRequestAlias)}
          />
        </Grid>

        <Grid size={3}>
          <InvoiceTotalInput disabled source={`${source}.amount`} currencySource="currency" label="Amount" />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container width="100%" columnSpacing="60px">
      <Grid size={3} display="flex" alignItems="flex-start" justifyContent="flex-start">
        <Box
          sx={{
            padding: '7px',
            border: '1px solid var(--mui-palette-border-default)',
            borderRadius: '3px',
            backgroundColor: 'var(--mui-palette-background-default)',
            color: 'var(--mui-palette-text-secondary)',
            mr: '5px',
          }}
        >
          {alias || `M${index !== undefined ? index + 1 : ''}`}
        </Box>
        <TextInput disabled={isStructureLocked} source={`${source}.milestoneName`} label="Name" />
      </Grid>

      <Grid size={3}>
        <EnumDropdown
          disabled={isStructureLocked}
          options={BILLING_MILESTONES}
          source={`${source}.milestoneType`}
          label="Milestone type"
        />
      </Grid>

      <Grid size={3}>
        <InvoiceTotalInput
          disabled={isFullyLocked}
          source={`${source}.amount`}
          currencySource="currency"
          label="Amount"
        />
      </Grid>
    </Grid>
  );
};

export default BillingProjectMilestonesInputs;
